import React from 'react'
import { Fade } from 'react-awesome-reveal'
import Resume from './Resume'
import TechStack from './TechStack'

const About = () => {
    return (
        <section id="about" className='navB'>
            <div className='mb-[6rem] lg:mb-[8rem]'>
                <Fade direction="up" triggerOnce={true}>
                    <h2
                        aria-label="projects-section"
                        className="my-projects pt-[2rem] lg:pt-[8rem] mb-[4rem] text-[2.75rem] tracking-[-0.25rem] leading-[3.375rem] md:text-[3.125rem] md:leading-[3.75rem] lg:mb-[5rem] lg:leading-[4.375rem] lg:text-[4.375rem] xl:mb-[7rem] xl:leading-[5rem]"
                    >
                        About
                    </h2>
                </Fade>
                <Fade direction="up" triggerOnce={true}>
                    <h3 className='text-[1.5rem] font-semibold lg:font-medium leading-[2rem] md:text-[2rem] lg:text-[3rem] md:leading-[3.9rem] tracking-[-.0125rem] md:tracking-[-.0225rem] lg:max-w-[80rem] lg:leading-[3.625rem] mb-[4rem]'>
                        Building products beyond the interface.
                    </h3>
                </Fade>
                <p className='about-text text-[1.5rem] leading-[2rem] tracking-[-.0125rem] md:tracking-[-.0225rem] md:text-[2rem] md:leading-[2.4rem] lg:text-[2rem] lg:leading-[3.625rem]'>
                    I believe great software should make life easier, not more complicated. Every interaction should help users accomplish their goals while helping businesses grow with confidence.
                    <br /><br />
                    As a Product-Focused Frontend Engineer, I build more than responsive interfaces. I think about user journeys, accessibility, performance, scalability, and how every product decision contributes to the overall experience.
                    <br /><br />
                    Building from scratch or fixing what's already there, I just focus on making things simple and enjoyable for the people actually using them.
                </p>
                <Resume />
                <TechStack />
            </div>
        </section>
    )
}

export default About